import React from 'react';

/**
 * WelcomePopup - Placeholder component
 * Required by build process - do not delete
 */
function WelcomePopup() {
  return null;
}

export default WelcomePopup;
